import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SHEET_SCRIPT, SHEET_STEPS } from "@/lib/sheetScript";
import { copyText } from "@/lib/copy";

export const SheetFix = ({ onConnected }) => {
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/admin/sheet").then((r) => { setInfo(r.data); setOpen(!r.data.live); });
  }, []);

  const save = async () => {
    setBusy(true);
    setMsg("");
    try {
      const { data } = await api.put("/admin/sheet", { url: link });
      setInfo(data);
      setMsg("Connected. New sign-ups now land in your sheet.");
      onConnected();
    } catch (e) {
      setMsg(e.response?.data?.detail || "Couldn't check that link. Try again.");
    }
    setBusy(false);
  };

  const copy = async () => { await copyText(SHEET_SCRIPT); setCopied(true); setTimeout(() => setCopied(false), 2000); };

  if (!info) return null;
  return (
    <section className={`sheet-fix ${info.live ? "is-live" : ""}`} data-testid="sheet-fix">
      <button type="button" className="sheet-head" onClick={() => setOpen(!open)} data-testid="sheet-fix-toggle">
        <span className={info.live ? "org-ok" : "org-wait"} data-testid="sheet-status">
          {info.live ? "Google Sheet connected" : "Google Sheet not connected"}
        </span>
        <span>{open ? "hide" : info.live ? "change link" : "fix it step by step"}</span>
      </button>
      {!info.live && <p className="sheet-why" data-testid="sheet-google-message">Google says: {info.message}</p>}
      {open && (
        <>
          <ol className="sheet-steps">
            {SHEET_STEPS.map((s, i) => (
              <li key={s.title} data-testid={`sheet-step-${i + 1}`}><b>{i + 1}</b><div><strong>{s.title}</strong><p>{s.body}</p></div></li>
            ))}
          </ol>
          <div className="sheet-form">
            <button type="button" className="pill" onClick={copy} data-testid="copy-script-button">{copied ? "copied" : "copy script"}</button>
            <input type="text" value={link} onChange={(e) => setLink(e.target.value)} placeholder="https://script.google.com/macros/s/.../exec" data-testid="sheet-link-input" />
            <button type="button" className="hero-cta" onClick={save} disabled={busy || !link.trim()} data-testid="sheet-link-save">{busy ? "testing..." : "save & test"}</button>
          </div>
          {msg && <p className="org-msg" data-testid="sheet-link-message">{msg}</p>}
        </>
      )}
    </section>
  );
};
